import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const Homepage = () => {
  return (
    <div style={{ cursor: "url('https://cdn-icons-png.flaticon.com/32/1828/1828911.png'), auto" }}>
    <div
      className="min-vh-100 d-flex flex-column"
      style={{
        backgroundColor: '#ffeae9', 
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          backgroundImage: 'url("/background.jpg")',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          opacity: 0.15,
          position: 'absolute',
          inset: 0,
          zIndex: 0,
        }}
      ></div>

      <div className="container py-5 text-center text-dark" style={{ zIndex: 1 }}>
        <div className="row align-items-center">
          <div className="col-md-6 mb-5 mb-md-0">
            <h1 className="display-4 fw-bold mb-4">Welcome to EduLink</h1>
            <div className="d-grid gap-3">
              <Link
                to="/signup/teacher"
                className="btn btn-lg text-white rounded-pill"
                style={{ backgroundColor: '#f5b5b5' }}
              >
                Sign up as Teacher
              </Link>
              <Link
                to="/signup/student"
                className="btn btn-lg text-white rounded-pill"
                style={{ backgroundColor: '#f5b5b5' }}
              >
                Sign up as Student
              </Link>
            </div>
            <p className="mt-3 text-dark fw-semibold">
              Already Linked? <Link to="/login">Log In</Link>
            </p>
          </div>

          <div className="col-md-6">
            <img
              src="/homepage-illustration.png"
              alt="Kid Illustration"
              className="img-fluid"
              style={{ maxHeight: '400px', zIndex: 1 }}
            />
          </div>
        </div>
      </div>

      <footer className="mt-auto bg-white bg-opacity-75 py-3" style={{ zIndex: 1 }}>
        <div className="container text-center">
          <img src="/final_logo.png" alt="EduLink Logo" width="100" className="mb-2" />
          <div className="d-flex justify-content-center gap-4 mb-2">
            <a href="/about" className="text-decoration-none text-dark">About</a>
            <a href="/contact" className="text-decoration-none text-dark">Contact</a>
            <a href="/privacy" className="text-decoration-none text-dark">Privacy Policy</a>
          </div>
          <div className="text-muted small">
            &copy; 2025 EduLink. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
    </div>
  );
};

export default Homepage;
